import api from '../lib/api'
import assign from 'lodash.assign'
import comment from './comment'

const name = 'comment4video'

export default {
  name,
  namespaced: true,
  modules: {
    comment
  },
  state: {
    data: {}
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async 'data:get' ({ commit }) {
      const data = await api.data.get()
      commit('set', { data })
    },
    async init ({ dispatch }) {
    }
  }
}
